import { useEffect, useState } from "react"

function useScreenWidth() {
  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    // Function to update the width state when the window is resized
    const handleResize = () => setWidth(window.innerWidth)

    // Add event listener for window resize
    window.addEventListener("resize", handleResize)

    // Cleanup function to remove event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return width
}

export default useScreenWidth
